// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Qp-z","imageAndVideoCount":"Rp-z","imageAndVideoContainer":"Sp-z","viewAllReviews":"Tp-z"};